import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import ad2c7630d78f53129e11cc5efb5b30c62b from "./generated-81848e29-c014-45de-bf66-5c633fd9b584.json";

import a63f51fa7b78b907a80e4bd1699783ff8b from "./generated-5d2cf0ce-cdb7-45ee-adb8-cffb7d0a91e9.json";

import af72c98fd1861719ac15af19059b3ab10b from "./generated-532266f7-369e-4c04-a9b2-9c4665715644.json";

import a7bf5c45da44c89515ba2358011c9246cb from "./generated-1675c724-5a38-4aa4-9fef-e7885a8d09a8.json";

import a3ead422e8575179087a7d742e386f0dbb from "./generated-6da7ca14-7e2d-4cf7-a096-0b2c6a2bd0f8.json";

import a228f9f82dbb69b36e7ac3ce89f93690bb from "./generated-3c6cd6d0-a5a4-4dd3-bbb5-704896d726df.json";

import a730cb6c664ee00a3329ba31318e72e9cb from "./generated-9030955d-4146-476c-a2b4-007f8fa1c5a5.json";

import a246cc029b4d5dcaf643c23d0d01b6b32b from "./generated-e4fc34d0-1d01-4d6f-bc00-7de3c2d7eb4f.json";

import a432509d450432d18e593dd0c59e37124b from "./generated-d5024c7d-1616-47f1-9902-2806f34089ff.json";

import a4ed8272290e25f31253f90167730c1f1b from "./generated-ff910dfb-d9d9-4fdf-bdd5-04aed8ff35a0.json";

import a66ddbfc42167af7c0aaba00cffa9a542b from "./generated-87969708-4e15-4c58-99f1-14740cd9c612.json";

import a9b954353387c7bd3f4891ee4d8441a85b from "./generated-a6f5980c-80e1-41a9-95dc-e6ed88d43807.json";

import a2b5eaf47edf8c57a5846cf3d1d1309d7b from "./generated-8116c9ef-d0c4-429b-9245-546231b80ac1.json";

import a727dc77db430bce7ee2445063091b4dbb from "./generated-00031741-41fa-44aa-8521-29945f9b62a0.json";

import ac5dda30efc53b64874e691562cf6bbd7b from "./generated-dabef4c2-6692-416c-8e2b-d1e428905fb7.json";

import a462761c7140ba0c852bd826cdb75da5fb from "./generated-68578643-5e47-45f5-b72f-c934abb621d6.json";

import a272505f30b90274249b9538b3ac83691b from "./generated-287f019a-1c1f-4479-87fe-a33b0b8d3bcb.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(ad2c7630d78f53129e11cc5efb5b30c62b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a63f51fa7b78b907a80e4bd1699783ff8b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(af72c98fd1861719ac15af19059b3ab10b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a7bf5c45da44c89515ba2358011c9246cb);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(a3ead422e8575179087a7d742e386f0dbb);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a228f9f82dbb69b36e7ac3ce89f93690bb);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a730cb6c664ee00a3329ba31318e72e9cb);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a246cc029b4d5dcaf643c23d0d01b6b32b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a432509d450432d18e593dd0c59e37124b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a4ed8272290e25f31253f90167730c1f1b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a66ddbfc42167af7c0aaba00cffa9a542b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a9b954353387c7bd3f4891ee4d8441a85b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a432509d450432d18e593dd0c59e37124b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a2b5eaf47edf8c57a5846cf3d1d1309d7b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a727dc77db430bce7ee2445063091b4dbb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a432509d450432d18e593dd0c59e37124b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(ac5dda30efc53b64874e691562cf6bbd7b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a462761c7140ba0c852bd826cdb75da5fb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a272505f30b90274249b9538b3ac83691b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(ac5dda30efc53b64874e691562cf6bbd7b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */